import { Link } from 'react-router';
import { ArrowRight, Check } from '@phosphor-icons/react';
import kitchenImage from '../../assets/chatserve/kitchen.webp';
import ordersImage from '../../assets/chatserve/orders.webp';
import '../LandingPage.css';

const features = [
  'Orders, tables and reservations',
  'Live kitchen and bar displays',
  'Fiscal receipts for Romania and Spain',
  'Delivery platform orders in one queue',
];

function ChatServeSection() {
  return (
    <section id="chatserve" className="chatserve-section section" aria-labelledby="chatserve-title">
      <div className="section-content chatserve-grid">
        <div className="chatserve-text reveal">
          <h2 id="chatserve-title" className="section-title">
            We run our own software in production
          </h2>
          <p className="section-lead section-lead--left">
            ChatServe is the system we built for restaurants and bars. Staff
            take orders, manage tables and reservations, send dishes to the
            kitchen and bar screens and print fiscal receipts from one app. We
            host it, update it and support it ourselves, so we know what an
            application needs after launch.
          </p>

          <ul className="check-list">
            {features.map((feature) => (
              <li key={feature}>
                <Check className="check-list-icon" size={18} weight="bold" aria-hidden="true" />
                <span>{feature}</span>
              </li>
            ))}
          </ul>

          <Link to="/products" className="text-link">
            See ChatServe
            <ArrowRight size={16} weight="bold" aria-hidden="true" />
          </Link>
        </div>

        <div className="chatserve-shots reveal reveal-delay-1">
          <img
            className="chatserve-shot chatserve-shot--back"
            src={ordersImage}
            alt="ChatServe order management screen listing orders by delivery type and status"
            width={2880}
            height={1800}
            loading="lazy"
            decoding="async"
          />
          <img
            className="chatserve-shot chatserve-shot--front"
            src={kitchenImage}
            alt="ChatServe kitchen display with order cards for each table"
            width={2880}
            height={1800}
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>
    </section>
  );
}

export default ChatServeSection;
